import { Servis } from "./Servis";
import { uiState } from "./uiState";

export function yardimAnahtari(path, liste) {
  const yol = (path || "").toLowerCase();
  let bulunan = null;
  for (const url of liste) {
    const tutar = yol === url || yol.startsWith(url + "/");
    if (tutar && (!bulunan || url.length > bulunan.length)) bulunan = url;
  }
  return bulunan;
}

// AdminLayout mount'ta bir kez, Yardım yönetimi (YeniYardim/DuzenleYardim) başarılı
// kayıt/güncelle/sil sonrası yeniden çağırır — metin eklenince/kalkınca buton kendiliğinden
// güncellensin diye (YARDIM-SAYFALARI-PLANI.md §4.1 "Tazeleme").
export function yardimliSayfalarTazele() {
  return Servis("GET", "GetYardimliSayfaListesi").then((res) => {
    if (res.status === 200 && Array.isArray(res.data)) {
      uiState.yardimliSayfalar = res.data.map((x) => x.Url);
      uiState.yardimListesiHata = false;
    } else {
      uiState.yardimListesiHata = true;
    }
  });
}
